import { AvatarGroup, ButtonBase, styled } from '@mui/material';
import { forwardRef } from 'react';

const CustomButtonBase = styled(ButtonBase)(({ theme }) => {
    return {
        borderRadius: '6px',
        padding: theme.spacing(2),
        '&:focus-visible': {
            background: theme.palette.ensightful.primary[50],
            outline: `${theme.palette.ensightful.secondary[400]} solid 3px`,
            outlineOffset: '4px',
        },
        '&:hover': {
            background: theme.palette.ensightful.primary[50],
        },
        '&:active': {
            background: theme.palette.ensightful.primary[100],
        },
    };
});

const CustomAvatarGroup = styled(AvatarGroup)(({ size, theme }) => {
    const mappedSize = {
        small: '1.5rem',
        medium: '2.5rem',
        large: '3.5rem',
        'x-large': '6rem',
    }[size];

    const mappedFontSize = {
        small: `${theme.typography.p3.fontSize.large}rem`,
        medium: `${theme.typography.p1.fontSize.large}rem`,
        large: `${theme.typography.h6.fontSize.large}rem`,
        'x-large': `${theme.typography.h3.fontSize.large}rem`,
    }[size];

    return {
        '& > .MuiAvatar-root:first-child': {
            width: mappedSize,
            height: mappedSize,
            fontSize: mappedFontSize,
        },
    };
});

const SIZES = ['small', 'medium', 'large', 'x-large'];

export default forwardRef(({ sx, className, size, onClick, ...rest }, ref) => {
    if (!SIZES.includes(size)) throw new Error(`Shell: Invalid size "${size}" in component AvatarGroup.`);

    return onClick ? (
        <CustomButtonBase sx={sx} className={className} onClick={onClick}>
            <CustomAvatarGroup ref={ref} {...rest} size={size} />
        </CustomButtonBase>
    ) : (
        <CustomAvatarGroup ref={ref} {...rest} sx={sx} className={className} size={size} />
    );
});
